export default "__VITE_ASSET__$prw9ItO__";